// src/config.js
const hostname = window.location.hostname;

let ENV = "production";
let API_URL = "https://klantportaalapi.nextgenworkspace.nl/api";
let REDIRECT_URI = "https://klantportaal.nextgenworkspace.nl/";

// 🔹 Check staging
if (hostname.includes("staging")) {
  ENV = "staging";
  API_URL = "https://klantportaalapi-staging.nextgenworkspace.nl/api";
  REDIRECT_URI = "https://klantportaal-staging.nextgenworkspace.nl/";
}

const config = {
  API_URL,
  TENANT_ID: "601774b8-d827-4636-92d7-934d5fceff0f",
  APP_NAME: "NextGen Workspace Klantportaal",
  ENV,
  REDIRECT_URI,
};

// 👀 Log altijd welke config actief is
console.log(
  `⚙️ Frontend config geladen: ENV=${ENV}, API_URL=${API_URL}, REDIRECT_URI=${REDIRECT_URI}`
);

export default config;
